import * as React from 'react'
import { ReactElement } from 'react'
import { FixedPriceType, isActiveFixedPriceType } from '../../config/registrationConfig'
import useFixedPriceTypes from '../../hooks/useFixedPriceTypes'
import { parseDate } from '../../helpers/dateHelper'
import BaseTagPicker, { BaseTagPickerProps } from './BaseTagPicker'

export type FixedPriceTypePickerProps = Omit<BaseTagPickerProps<FixedPriceType>, 'getEntityLabel' | 'getEntityValue' | 'entities'> &
    Partial<Pick<BaseTagPickerProps<FixedPriceType>, 'getEntityLabel'>> & {
        date?: string
        currency?: string
    }

export default function FixedPriceTypePicker(props: FixedPriceTypePickerProps): ReactElement {
    const { fixedPriceTypes } = useFixedPriceTypes()

    return (
        <BaseTagPicker<FixedPriceType>
            entities={fixedPriceTypes}
            filter={entity =>
                //type is active and the correct currency, or the type is selected.
                (isActiveFixedPriceType(entity, parseDate(props.date)) && (!props.currency || props.currency === entity.currency)) ||
                (props.selectedOptions || []).includes(entity.id)
            }
            alphabetical
            getEntityLabel={entity => entity.name}
            getEntityTagLabel={entity => entity.code}
            getEntityTagSecondaryContent={entity => entity.name}
            getEntityValue={type => type.id}
            placeholderKey={'base.fixedpricetypecombobox.placeholder'}
            {...props}
        />
    )
}
